const BASE_URL = 'http://43.205.42.216:8000'

export const SIGN_UP_USER = `${BASE_URL}/users/sign-up/`
export const LOGIN_IN_OTP = `${BASE_URL}/users/login/otp/`
export const OTP = `${BASE_URL}/security/get-otp/`
export const DOCTOR = `${BASE_URL}/doctors/`
export const DOCTOR_SLOT_LIST = `${BASE_URL}/doctors/doctor_slots/`
export const BOOK_APPOINTMENT = `${BASE_URL}/doctors/appointments/`
